import bg from "./translations/bg.json";
import en from "./translations/en.json";
import eo from "./translations/eo.json";
import es from "./translations/es.json";
import fr from "./translations/fr.json";
import pt from "./translations/pt.json";
import zh from "./translations/zh.json";

export default {
  bg,
  en,
  eo,
  es,
  fr,
  pt,
  zh,
};
